// extracted by mini-css-extract-plugin
export var base = "_2i-0";
export var updateBanner = "_2i-1";